"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plantNurseryService = void 0;
var _http = _interopRequireDefault(require("@/config/http"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var lots = {
  fetchLots: function fetchLots(params) {
    return _http.default.get("/plant-nursery/lots", {
      params: params
    });
  },
  updateLot: function updateLot(lotId, data) {
    return _http.default.patch("/plant-nursery/lots/".concat(lotId), data);
  },
  deleteLot: function deleteLot(lotId) {
    return _http.default.delete("/plant-nursery/lots/".concat(lotId));
  },
  createDispatch: function createDispatch(lotId, data) {
    return _http.default.post("/plant-nursery/lots/".concat(lotId, "/dispatch"), data);
  },
  dispatchLot: function dispatchLot(lotId, data) {
    return _http.default.post("/plant-nursery/lots/".concat(lotId, "/dispatch"), data);
  },
  reportMortality: function reportMortality(lotId, data) {
    return _http.default.post("/plant-nursery/lots/".concat(lotId, "/mortalities"), data);
  },
  transferLot: function transferLot(lotId, data) {
    return _http.default.post("/plant-nursery/lots/".concat(lotId, "/transfer"), data);
  },
  createLotInventory: function createLotInventory(lotId, data) {
    return _http.default.post("/plant-nursery/lots/".concat(lotId, "/lot-inventories"), data);
  },
  updateLotInventory: function updateLotInventory(inventoryId, data) {
    return _http.default.patch("/plant-nursery/lots/lot-inventories/".concat(inventoryId), data);
  },
  updateLotInventoryStrength: function updateLotInventoryStrength(inventoryId, data) {
    return _http.default.patch("/plant-nursery/lots/lot-inventories/".concat(inventoryId), data);
  },
  mergeLots: function mergeLots(data) {
    return _http.default.post("/plant-nursery/lots/merge", data);
  },
  moveLot: function moveLot(lotId, data) {
    return _http.default.post("/plant-nursery/lots/".concat(lotId, "/move"), data);
  },
  fetchLotOperations: function fetchLotOperations(lotId, params) {
    return _http.default.get("/plant-nursery/lots/".concat(lotId, "/operations"), {
      params: params
    });
  }
};
var graftingLots = {
  createGraftingLot: function createGraftingLot(data) {
    return _http.default.post("/plant-nursery/grafting-lots", data);
  },
  graftLot: function graftLot(lotId, data) {
    return _http.default.post("/plant-nursery/grafting-lots/".concat(lotId, "/graft"), data);
  },
  partialGraftLot: function partialGraftLot(lotId, data) {
    return _http.default.post("/plant-nursery/grafting-lots/".concat(lotId, "/graft-partial"), data);
  },
  graftSuccessRate: function graftSuccessRate(lotId, data) {
    return _http.default.post("/plant-nursery/grafting-lots/".concat(lotId, "/graft-success-rate"), data);
  },
  mergeGraftingLots: function mergeGraftingLots(data) {
    return _http.default.post("/plant-nursery/grafting-lots/merge", data);
  }
};
var cuttingLots = {
  createCuttingLot: function createCuttingLot(data) {
    return _http.default.post("/plant-nursery/cutting-lots", data);
  }
};
var stages = {
  fetchStages: function fetchStages(params) {
    return _http.default.get("/plant-nursery/stages", {
      params: params
    });
  },
  createStage: function createStage(data) {
    return _http.default.post("/plant-nursery/stages", data);
  }
};
var sections = {
  fetchSections: function fetchSections(params) {
    return _http.default.get("/plant-nursery/sections", {
      params: params
    });
  },
  createSection: function createSection(data) {
    return _http.default.post("/plant-nursery/sections", data);
  },
  updateSection: function updateSection(sectionId, data) {
    return _http.default.patch("/plant-nursery/sections/".concat(sectionId), data);
  },
  createSectionRow: function createSectionRow(sectionId, data) {
    return _http.default.post("/plant-nursery/sections/".concat(sectionId, "/rows"), data);
  },
  updateSectionRow: function updateSectionRow(rowId, data) {
    return _http.default.patch("/plant-nursery/section-rows/".concat(rowId), data);
  },
  deleteSectionRow: function deleteSectionRow(rowId) {
    return _http.default.delete("/plant-nursery/section-rows/".concat(rowId));
  },
  deleteSection: function deleteSection(sectionId) {
    return _http.default.delete("/plant-nursery/sections/".concat(sectionId));
  }
};
var reasons = {
  fetchReasons: function fetchReasons(params) {
    return _http.default.get("/plant-nursery/reasons", {
      params: params
    });
  },
  createReason: function createReason(data) {
    return _http.default.post("/plant-nursery/reasons", data);
  }
};
var varieties = {
  fetchVarieties: function fetchVarieties(params) {
    return _http.default.get("/plant-nursery/varieties", {
      params: params
    });
  },
  createVariety: function createVariety(data) {
    return _http.default.post("/plant-nursery/varieties", data);
  },
  deleteVariety: function deleteVariety(varietyId) {
    return _http.default.delete("/plant-nursery/varieties/".concat(varietyId));
  }
};
var customers = {
  fetchCustomers: function fetchCustomers(params) {
    return _http.default.get("/plant-nursery/customers", {
      params: params
    });
  },
  createCustomer: function createCustomer(data) {
    return _http.default.post("/plant-nursery/customers", data);
  },
  updateCustomer: function updateCustomer(customerId, data) {
    return _http.default.put("/plant-nursery/customers/".concat(customerId), data);
  },
  deleteCustomer: function deleteCustomer(customerId) {
    return _http.default.delete("/plant-nursery/customers/".concat(customerId));
  }
};
var contracts = {
  fetchContracts: function fetchContracts(params) {
    return _http.default.get("/plant-nursery/contracts", {
      params: params
    });
  },
  createContract: function createContract(data) {
    return _http.default.post("/plant-nursery/contracts", data);
  },
  updateContract: function updateContract(contractId, data) {
    return _http.default.put("/plant-nursery/contracts/".concat(contractId), data);
  },
  deleteContract: function deleteContract(contractId) {
    return _http.default.delete("/plant-nursery/contracts/".concat(contractId));
  }
};
var reports = {
  fetchLotsReports: function fetchLotsReports(params) {
    return _http.default.get("/plant-nursery/lots/reports", {
      params: params
    });
  }
};
var plantNurseryService = exports.plantNurseryService = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, lots), graftingLots), cuttingLots), stages), sections), reasons), varieties), customers), contracts), reports);